"use strict";

var _interopRequireDefault = require("/opt/jenkins/workspace/sit-app-client/node_modules/@babel/runtime/helpers/interopRequireDefault");

require("vant/es/icon/style/less");

var _icon = _interopRequireDefault(require("vant/es/icon"));

require("vant/es/col/style/less");

var _col = _interopRequireDefault(require("vant/es/col"));

require("vant/es/row/style/less");

var _row = _interopRequireDefault(require("vant/es/row"));

require("vant/es/loading/style/less");

var _loading = _interopRequireDefault(require("vant/es/loading"));

require("vant/es/skeleton/style/less");

var _skeleton = _interopRequireDefault(require("vant/es/skeleton"));

var _vue = _interopRequireDefault(require("vue"));

_vue.default.use(_skeleton.default);

_vue.default.use(_loading.default);

_vue.default.use(_row.default);

_vue.default.use(_col.default);

_vue.default.use(_icon.default);